import React from 'react'
import Success from 'components/icons/Success.js'
import ContentNormal from 'components/elements/ContentNormal'
import { Box } from '@mui/material'
import Headline5 from 'components/elements/Headline5'
import ButtonLarge1 from 'components/elements/ButtonLarge1'
import { useNavigate } from 'react-router-dom'

export default function RegisterCreated({mobilePhoneNumber}) {
  const navigate = useNavigate()

  return (
    <Box display={'flex'} flexDirection={'column'} gap={4} data-cy='register.sucess' alignItems={'center'} width={'100%'}>
      <Box style={{ margin: 'auto', marginTop: '10%', alignSelf: 'center', width: '100px' }}>
        <Success />
      </Box>
      <Box display={'flex'} flexDirection={'column'} alignItems={'center'} gap={1}>
        <Headline5
          translationKey="_REGISTER_CREATED_HEADLINE_"
          fallbackText="Din bruger er oprettet"
        />
        <ContentNormal className='text-center'
          translationKey="_REGISTER_CREATED_TEXT_"
          fallbackText="Du kan nu logge ind med din email eller dit mobilnummer."
        />
      </Box>
      <Box>
        <ButtonLarge1
          translationKey=""
          fallbackText="Log Ind"
          onClick={() => navigate(`/login?identifier=${mobilePhoneNumber}`)}
        />
      </Box>
    </Box>
  )
}
